import axios from "../../../../service/axios";
import { validationSchema } from "../Address/helpers";
import * as yup from "yup";

export const onSelectAddress = (selectedAddress, props) => {
  props.setFormValues((state) => {
    const prevValue = [...state.upsAccountAddress];
    let upsAccountAddress = [...state.upsAccountAddress];

    upsAccountAddress.splice(props.addressIndex, 1, "");
    upsAccountAddress = upsAccountAddress.filter((item) => item !== "");
    upsAccountAddress.splice(props.addressIndex, 0, {
      ...prevValue[props.addressIndex],
      ...selectedAddress,
    });

    props.addressFields.forEach(({ fieldId, key }) => {
      upsAccountAddress[props.addressIndex][fieldId] &&
        delete state.formValues.errors[key];
    });

    return {
      ...state,
      upsAccountAddress,
      validForm: validateForm(upsAccountAddress),
    };
  });
};

export const onAddAddress = (setFormValues, addToObject = {}) => {
  setFormValues((state) => {
    let upsAccountAddress = [...state.upsAccountAddress];
    upsAccountAddress.push({
      upsAccountNumber: "",
      streetAddress: "",
      suiteUnitFloor: null,
      city: "",
      state: "",
      zipCode: "",
      country: "",
      ...addToObject,
    });
    return {
      ...state,
      upsAccountAddress,
    };
  });
};

export const onDeleteAddress = (
  updateUPSAddresses,
  setFormValues,
  address,
  index
) => {
  if (address.id) {
    axios()
      .delete("/address/deleteAddress", { data: address })
      .then((res) => {
        setFormValues((state) => {
          let upsAccountAddress = [...state.upsAccountAddress];
          upsAccountAddress.splice(index, 1, "");
          upsAccountAddress = upsAccountAddress.filter((item) => item !== "");

          updateUPSAddresses(upsAccountAddress);
          return {
            ...state,
            errors: {},
            validForm: validateForm(upsAccountAddress),
            upsAccountAddress,
            resetValues: { ...state.resetValues, upsAccountAddress },
          };
        });
      })
      .catch((err) =>
        setFormValues((state) => ({
          ...state,
          requestErrorMessage: `Unable to delete UPS address.`,
        }))
      );
  } else {
    setFormValues((state) => {
      let upsAccountAddress = [...state.upsAccountAddress];
      upsAccountAddress.splice(index, 1, "");
      upsAccountAddress = upsAccountAddress.filter((item) => item !== "");

      return {
        ...state,
        errors: {},
        validForm: validateForm(upsAccountAddress),
        upsAccountAddress,
      };
    });
  }
};

export const validateForm = (upsAccountAddress) => {
  let validForm = true;

  const checkFields = [
    "streetAddress",
    "city",
    "state",
    "zipCode",
    "country",
    "addressSubType",
    "upsAccountNumber",
  ];
  upsAccountAddress.map((address, index) => {
    Object.keys(address).forEach((field) => {
      if (checkFields.includes(field)) {
        if (address[field] === "") {
          validForm = false;
        }
      }
    });
  });

  return validForm;
};

export const resetValues = (setFormValues) =>
  setFormValues((state) => ({
    ...state,
    ...state.resetValues,
    submitSucess: null
  }));

export const handleUpsAddressValidation = (fieldInfo, setFormValues) => {
  const { field, fieldValue } = fieldInfo;

  yup
    .reach(validationSchema, `${[field.fieldId]}`)
    .validate(fieldValue)
    .then((value) => {
      setFormValues((state) => {
        let errors = { ...state.formValues.errors };
        errors[field.key] && delete errors[field.key];

        return { ...state, formValues: { ...state.formValues, errors } };
      });
    })
    .catch((err) => {
      setFormValues((state) => ({
        ...state,
        formValues: {
          ...state.formValues,
          errors: {
            ...state.formValues.errors,
            [field.key]: err.message,
          },
        },
      }));
    });
};

export const extractUPSAddress = (vendorDetails) => {
  return Array.isArray(vendorDetails.upsAccountAddress) &&
    vendorDetails.upsAccountAddress.length
    ? vendorDetails.upsAccountAddress
    : [
        {
          streetAddress: "",
          city: "",
          state: "",
          zipCode: "",
          country: "",
          category: "UPS",
          vendorProfileId: vendorDetails.vendorProfileId,
          duns: vendorDetails.duns,
          email: vendorDetails.userEmail,
        },
      ];
};
